import { Badge } from "./ui/badge";

const STYLES = {
    "Premium": "border-amber-300 bg-amber-100 text-amber-900",
    "1. Kalite": "border-emerald-300 bg-emerald-100 text-emerald-800",
    "2. Kalite": "border-sky-300 bg-sky-100 text-sky-800",
    "Standart": "border-stone-300 bg-stone-100 text-stone-700",
};

export default function QualityBadge({ quality, tid }) {
    if (!quality) return null;
    return (
        <Badge variant="outline" className={`ml-1.5 align-middle text-[10px] ${STYLES[quality] || STYLES["Standart"]}`} data-testid={tid ? `quality-badge-${tid}` : "quality-badge"}>
            {quality}
        </Badge>
    );
}
